$(function () {
  $('#headerMenu').menus({})
  $('.timer').counter()
})
